/*
 * Ocupações/rendas (tipo, ocupação e valor) do candidato e dos integrantes do
 * grupo familiar. Os tipos são os mesmos do TipoRenda do SysUnaerpWeb e do JSF.
 */
export const TIPOS_RENDA = [
    { valor: 'P', descricao: 'Principal', detalhe: 'Salário, Aposentadoria, etc.' },
    { valor: 'E', descricao: 'Eventual', detalhe: 'Autônomo, Bico, Outros' },
    { valor: 'O', descricao: 'Outras fontes de renda', detalhe: '' }
];

export const descricaoTipoRenda = (tipo) => {
    const encontrado = TIPOS_RENDA.find(item => item.valor === String(tipo || '').trim());
    return encontrado ? encontrado.descricao : '';
};

const OCUPACAO_TAMANHO_MAXIMO = 255;

/* Soma dos valores, em centavos para não acumular erro de ponto flutuante. */
export const somarRendas = (rendas = []) => {
    const centavos = (rendas || []).reduce((acc, renda) => {
        const valor = Number(renda?.vlrRenda);
        return acc + (Number.isFinite(valor) ? Math.round(valor * 100) : 0);
    }, 0);
    return centavos / 100;
};

/*
 * Ocupações distintas (sem diferenciar maiúsculas) unidas por " + ", como o
 * ComposicaoFamiliar.sincronizarRendaLegado do back grava em DSOCUPACAO.
 */
export const consolidarOcupacoes = (rendas = []) => {
    const vistas = new Set();
    const ocupacoes = [];
    (rendas || []).forEach(renda => {
        const ocupacao = String(renda?.ocupacao || '').trim();
        const chave = ocupacao.toLowerCase();
        if (ocupacao && !vistas.has(chave)) {
            vistas.add(chave);
            ocupacoes.push(ocupacao);
        }
    });
    return ocupacoes.join(' + ').slice(0, OCUPACAO_TAMANHO_MAXIMO);
};

/*
 * Rendas de um integrante. Sem a lista (dado antigo), monta uma renda
 * "Principal" a partir de ocupacao/rendaBruta, como o back faz para o membro
 * que ainda não tem linhas em CBCOMPOSICAOFAMILIARRENDA.
 */
export const rendasDoMembro = (membro) => {
    if (!membro) return [];
    if (Array.isArray(membro.rendas)) return membro.rendas;

    // Mesma regra do possuiRendaLegadaNaoConvertida: renda > 0 ou ocupação informada.
    const ocupacao = String(membro.ocupacao || '').trim();
    const temRenda = Number(membro.rendaBruta) > 0;
    if (!ocupacao && !temRenda) return [];

    return [{
        tpRenda: 'P',
        ocupacao: ocupacao || 'Não informada',
        vlrRenda: Number(membro.rendaBruta) || 0
    }];
};

export const formatarMoeda = (valor) => (Number(valor) || 0)
    .toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
